import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { AngleField } from '@paragon/material';

import { typeToPluralUserVisibleString } from '../../../../library/selection/types';
import { PartialRotationTransformation, TransformableType } from '../../../../library/transformations/types';
import { isTransformationFullyDefined } from '../../../../library/transformations/validation';
import {
  applyPendingTransformationIfFullyDefined,
  cancelTransformation,
} from '../../../../store/actions/layout/transformationActions';
import { transformationBeganOrUpdated } from '../../../../store/slices/applicationSlice';
import { useAppDispatch } from '../../../hooks';
import { LayoutPointPickerField } from '../../subpanels/insertions/truss-envelope/LayoutPointPickerField';

export function RotationControls(props: {
  targetType: TransformableType;
  transformation: PartialRotationTransformation;
}) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Typography sx={{ padding: 1 }}>
        {props.transformation.duplicate ? 'Duplicate and rotate' : 'Rotate'} the selected{' '}
        {typeToPluralUserVisibleString(props.targetType)} around a center point by a specified angle.
      </Typography>

      <Box sx={{ margin: 1, padding: 1 }}>
        <LayoutPointPickerField
          label="Center Point"
          value={props.transformation.center}
          target="transformation-center"
        />
      </Box>

      <Box sx={{ margin: 1, padding: 1 }}>
        <AngleField
          label="Angle"
          value={props.transformation.angle}
          onSubmit={(value: number, { finalizing }) => {
            dispatch(transformationBeganOrUpdated({ ...props.transformation, angle: value }));

            if (finalizing) {
              dispatch(applyPendingTransformationIfFullyDefined()); // safe; it does nothing unless the transformation is fully defined
            }
          }}
        />
      </Box>

      <Box sx={{ padding: 1, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={() => dispatch(cancelTransformation())}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={() => void dispatch(applyPendingTransformationIfFullyDefined())}
          disabled={!isTransformationFullyDefined(props.transformation)}
        >
          Apply
        </Button>
      </Box>
    </>
  );
}
